module.exports = __webpack_public_path__ + "static/media/math-wallet.87996a42.svg";